module.exports = __webpack_public_path__ + "static/media/11_tn.151982aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/11_tn.jpg
// module id = 501
// module chunks = 0